import { NavigateOptions } from '@tanstack/react-router'
import {
  BANK_CLIENT_USERS_PATH,
  BankAccountsPath,
  BankApplicationPaths,
  ContactsPath,
  LicensesPath,
  routes
} from 'commons/constants/routes'

import { GlobalSearchType } from '../../../types/GlobalSearchResponse'

export const getNavigateOptions = (
  itemId: number | string,
  section: GlobalSearchType
): { to: NavigateOptions['to']; params?: NavigateOptions['params']; search?: NavigateOptions['search'] } => {
  switch (section) {
    case 'companies':
      return { to: routes.bank.relationships.details, params: { id: itemId } }
    case 'applications':
      return { to: BankApplicationPaths.DETAILS, params: { applicationId: itemId } }
    case 'contacts':
      return { to: ContactsPath.DETAILS, params: { contactId: itemId } }
    case 'licenses':
      return { to: LicensesPath.DETAILS, params: { licenseId: itemId } }
    case 'bank_accounts':
      return { to: BankAccountsPath.DETAILS, params: { bankAccountId: itemId } }
    case 'client_users':
      return { to: BANK_CLIENT_USERS_PATH, search: { userId: itemId.toString() } }
  }
}
